import { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react'

export function useIsTruncated<T extends HTMLElement>({ paused = false }: { paused?: boolean } = {}) {
  const ref = useRef<T>(null)
  const [isTruncated, setIsTruncated] = useState(false)

  const measure = useCallback(() => {
    const node = ref.current
    if (!node || paused) return

    setIsTruncated(node.scrollWidth > node.clientWidth || node.scrollHeight > node.clientHeight)
  }, [paused])

  useLayoutEffect(measure)

  useEffect(() => {
    const node = ref.current
    if (!node || typeof ResizeObserver === 'undefined') return

    const observer = new ResizeObserver(measure)
    observer.observe(node)

    return () => observer.disconnect()
  }, [measure])

  return { ref, isTruncated }
}
